<div class="w-full mx-auto p-0 sm:py-1.5">
  <!-- Mobile View: Compact Horizontal Layout (Mobile Only) -->
  <div class="block md:hidden mb-4">
    <div class="flex items-center justify-center overflow-x-auto px-2 pb-2">
      <div class="flex items-center space-x-2 min-w-max">
        @for (step of steps; track step.id; let i = $index; let last = $last) {
          <div class="flex items-center">
            <!-- Step Circle (Mobile) -->
            <div
              class="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-xs font-medium transition-colors duration-200"
              [class.bg-[#1FC16B]]="i < currentStepIndex"
              [class.bg-purple-600]="i === currentStepIndex"
              [class.text-white]="i <= currentStepIndex"
              [class.bg-gray-200]="i > currentStepIndex"
              [class.text-gray-600]="i > currentStepIndex"
              [class.border]="i > currentStepIndex"
              [class.border-gray-300]="i > currentStepIndex"
            >
              @if (i < currentStepIndex) {
                <span>✓</span>
              } @else {
                <span>{{ i + 1 }}</span>
              }
            </div>

            <!-- Arrow Separator (Mobile) -->
            @if (!last) {
              <div
                class="mx-1 flex items-center"
                [class.text-[#1FC16B]]="i < currentStepIndex"
                [class.text-purple-600]="i === currentStepIndex"
                [class.text-gray-400]="i > currentStepIndex"
              >
                <svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor" class="transform rotate-0">
                  <path d="M6.5 3L11.5 8L6.5 13L5.5 12L9.5 8L5.5 4L6.5 3Z" fill="currentColor" />
                </svg>
                <svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor" class="transform rotate-0 -ml-1.5">
                  <path d="M6.5 3L11.5 8L6.5 13L5.5 12L9.5 8L5.5 4L6.5 3Z" fill="currentColor" />
                </svg>
              </div>
            }
          </div>
        }
      </div>
    </div>
    <!-- Current Step Title (Mobile) -->
    <div class="text-center px-4">
      <h3 class="text-sm font-medium text-purple-600 transition-colors duration-200">
        {{ currentStep() ? currentStep().title : '' }}
      </h3>
    </div>
  </div>

  <!-- Tablet View: Desktop Style (4 or fewer steps) -->
  @if (steps.length <= 4) {
    <div class="hidden md:block lg:hidden mb-6 sm:mb-2.5">
      <div class="flex items-center">
        <div class="flex items-center space-x-4">
          @for (step of steps; track step.id; let i = $index; let last = $last) {
            <div class="flex items-center">
              <!-- Step Circle -->
              <div
                class="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-sm font-medium transition-colors duration-200"
                [class.bg-[#1FC16B]]="i < currentStepIndex"
                [class.bg-purple-600]="i === currentStepIndex"
                [class.text-white]="i <= currentStepIndex"
                [class.bg-gray-200]="i > currentStepIndex"
                [class.text-gray-600]="i > currentStepIndex"
                [class.border]="i > currentStepIndex"
                [class.border-gray-300]="i > currentStepIndex"
              >
                @if (i < currentStepIndex) {
                  <span>✓</span>
                } @else {
                  <span>{{ i + 1 }}</span>
                }
              </div>

              <!-- Step Content -->
              <div class="ml-3">
                <h3
                  class="text-sm font-medium whitespace-nowrap transition-colors duration-200"
                  [class.text-[#1FC16B]]="i < currentStepIndex"
                  [class.text-purple-600]="i === currentStepIndex"
                  [class.text-gray-600]="i > currentStepIndex"
                >
                  {{ step.title }}
                </h3>
              </div>

              <!-- Arrow Separator -->
              @if (!last) {
                <div
                  class="ml-4 flex items-center"
                  [class.text-[#1FC16B]]="i < currentStepIndex"
                  [class.text-purple-600]="i === currentStepIndex"
                  [class.text-gray-400]="i > currentStepIndex"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" class="transform rotate-0">
                    <path d="M6.5 3L11.5 8L6.5 13L5.5 12L9.5 8L5.5 4L6.5 3Z" fill="currentColor" />
                  </svg>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" class="transform rotate-0 -ml-2">
                    <path d="M6.5 3L11.5 8L6.5 13L5.5 12L9.5 8L5.5 4L6.5 3Z" fill="currentColor" />
                  </svg>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }

  <!-- Tablet View: Compact Mobile Style (More than 4 steps) -->
  @if (steps.length > 4) {
    <div class="hidden md:block lg:hidden my-2">
      <div class="flex items-center justify-center overflow-x-auto px-2 pb-2">
        <div class="flex items-center space-x-2 min-w-max">
          @for (step of steps; track step.id; let i = $index; let last = $last) {
            <div class="flex items-center">
              <!-- Step Circle (Tablet) -->
              <div
                class="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-xs font-medium transition-colors duration-200"
                [class.bg-[#1FC16B]]="i < currentStepIndex"
                [class.bg-purple-600]="i === currentStepIndex"
                [class.text-white]="i <= currentStepIndex"
                [class.bg-gray-200]="i > currentStepIndex"
                [class.text-gray-600]="i > currentStepIndex"
                [class.border]="i > currentStepIndex"
                [class.border-gray-300]="i > currentStepIndex"
              >
                @if (i < currentStepIndex) {
                  <span>✓</span>
                } @else {
                  <span>{{ i + 1 }}</span>
                }
              </div>

              <!-- Arrow Separator (Tablet) -->
              @if (!last) {
                <div
                  class="mx-1 flex items-center"
                  [class.text-[#1FC16B]]="i < currentStepIndex"
                  [class.text-purple-600]="i === currentStepIndex"
                  [class.text-gray-400]="i > currentStepIndex"
                >
                  <svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor" class="transform rotate-0">
                    <path d="M6.5 3L11.5 8L6.5 13L5.5 12L9.5 8L5.5 4L6.5 3Z" fill="currentColor" />
                  </svg>
                  <svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor" class="transform rotate-0 -ml-1.5">
                    <path d="M6.5 3L11.5 8L6.5 13L5.5 12L9.5 8L5.5 4L6.5 3Z" fill="currentColor" />
                  </svg>
                </div>
              }
            </div>
          }
        </div>
      </div>
      <!-- Current Step Title (Tablet) -->
      <div class="text-center px-4">
        <h3 class="text-sm font-medium text-purple-600 transition-colors duration-200">
          {{ currentStep() ? currentStep().title : '' }}
        </h3>
      </div>
    </div>
  }

  <!-- Desktop View: Original Design -->
  <div class="hidden lg:block mb-6 sm:my-2">
    <div class="flex items-center">
      <div class="flex items-center space-x-4">
        @for (step of steps; track step.id; let i = $index; let last = $last) {
          <div class="flex items-center">
            <!-- Step Circle -->
            <div
              class="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-sm font-medium transition-colors duration-200"
              [class.bg-[#1FC16B]]="i < currentStepIndex"
              [class.bg-purple-600]="i === currentStepIndex"
              [class.text-white]="i <= currentStepIndex"
              [class.bg-gray-200]="i > currentStepIndex"
              [class.text-gray-600]="i > currentStepIndex"
              [class.border]="i > currentStepIndex"
              [class.border-gray-300]="i > currentStepIndex"
            >
              @if (i < currentStepIndex) {
                <span>✓</span>
              } @else {
                <span>{{ i + 1 }}</span>
              }
            </div>

            <!-- Step Content -->
            <div class="ml-3">
              <h3
                class="text-sm font-medium whitespace-nowrap transition-colors duration-200"
                [class.text-[#1FC16B]]="i < currentStepIndex"
                [class.text-purple-600]="i === currentStepIndex"
                [class.text-gray-600]="i > currentStepIndex"
              >
                {{ step.title }}
              </h3>
            </div>

            <!-- Arrow Separator -->
            @if (!last) {
              <div
                class="ml-4 flex items-center"
                [class.text-[#1FC16B]]="i < currentStepIndex"
                [class.text-purple-600]="i === currentStepIndex"
                [class.text-gray-400]="i > currentStepIndex"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" class="transform rotate-0">
                  <path d="M6.5 3L11.5 8L6.5 13L5.5 12L9.5 8L5.5 4L6.5 3Z" fill="currentColor" />
                </svg>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" class="transform rotate-0 -ml-2">
                  <path d="M6.5 3L11.5 8L6.5 13L5.5 12L9.5 8L5.5 4L6.5 3Z" fill="currentColor" />
                </svg>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>

